import { useEffect } from 'react';

export const useMetaDescription = (description: string) => {
  useEffect(() => {
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');

    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }

    const previousContent = meta.content;
    meta.content = description;

    return () => {
      if (previousContent) {
        meta.content = previousContent;
      } else {
        meta.removeAttribute('content');
      }
    };
  }, [description]);
};
